import styled from '@emotion/styled'

export const Item = styled.div`
  padding: 5px 0;
`

export const Label = styled.span`
  color: rgb(160,160,160);
  display: block;
  font-size: 11px;
  padding-bottom: 4px;
`

export const Content = styled.div`
  &:empty:before {
    content: 'não informado';
    color: #c8c8c8;
    font-size: 12px;
  }
`
